import {BaseService} from "./base.service";

class RelconsultationspecialtyService extends BaseService {

    constructor() {
        super('api/rel-consultations-specialtys')
    }

}

export const relconsultationspecialtyService = new RelconsultationspecialtyService();
